import * as React from 'react';
import { defaultSystemConfiguration } from '../../state/App/state';
import { SystemConfiguration } from './type';

const SystemConfigurationContext = React.createContext<SystemConfiguration>(
  defaultSystemConfiguration
);

export default SystemConfigurationContext;
